
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  Civility.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Civility.ts

import {Contact } from "./Contact";
export class Civility {

  // int Id
  public Id: number=0;

  // string Cod
  public Cod?: string=null;

  // string LblCod
  public LblCod?: string=null;

  // ICollection<Contact> Contacts
  public Contacts: Contact[]=[];
}